import axios from "api/axios.js";

const UPDATE_URL = "/clients";

export async function updateClient(clientData, _id) {
  try {
    const response = await axios.put(`${UPDATE_URL}/${_id}`, clientData, {
      headers: { "Content-Type": "application/json" },
      withCredentials: true,
    });
    // Handle success here, e.g., redirecting the user or displaying a success message
    return response;
  } catch (error) {
    // Handle error here, e.g., displaying an error message to the user
    console.error(error);
    return error;
  }
}
